import { useEffect, useState } from 'react';

import Box from '@zenbusiness/zui/Box';
import GlobalStyles from '@zenbusiness/zui/GlobalStyles';
import Modal from '@zenbusiness/zui/Modal';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';
import PropTypes from 'prop-types';

import CloseIcon from '@mui/icons-material/Close';

import * as mitekScienceSDK from '#public/mitekSDK/mitek-science-sdk';

import { CAPTURE_FRAME_COMMAND, MITEK_SDK_CSS_STYLE_OVERRIDES } from './constants';
import { CaptureImageStyles, CloseIconStyles, ToolKitBoxStyles } from './styles';

const StyledCaptureImage = styled('img')(CaptureImageStyles);
const StyledCloseIcon = styled(CloseIcon)(CloseIconStyles);
const StyledToolKitBox = styled(Box)(ToolKitBoxStyles);
export default function RenderContainer({
  isCaptureInProgress,
  isMitekSdkReady,
  renderContainer,
  stopImageCapture
}) {
  const [autoCaptureIsOn, setAutoCaptureIsOn] = useState(true);

  const captureOnClick = () => mitekScienceSDK.cmd(CAPTURE_FRAME_COMMAND);

  useEffect(() => {
    if (isMitekSdkReady) {
      setAutoCaptureIsOn(true);
    }
  }, [isMitekSdkReady]);

  return (
    <Modal
      container={renderContainer}
      open={isCaptureInProgress}
      sx={{
        transform: 'none'
      }}
    >
      <>
        <GlobalStyles styles={MITEK_SDK_CSS_STYLE_OVERRIDES} />
        <Stack
          aria-label="Image capture viewfinder"
          id="banking-ui-mitek-sdk-container"
          sx={{ width: '100%', height: '100%' }}
        >
          {isMitekSdkReady && (
            <>
              <StyledToolKitBox>
                {!autoCaptureIsOn && (
                  <StyledCaptureImage
                    alt="Click to capture"
                    onClick={captureOnClick}
                    src="https://res.cloudinary.com/zenbusiness/q_auto,w_32/v1/shared-assets/s2/vector/shutter-button.svg"
                  />
                )}
              </StyledToolKitBox>
              <StyledCloseIcon
                aria-label="Quit image capture"
                onClick={stopImageCapture}
              />
            </>
          )}
        </Stack>
      </>
    </Modal>
  );
}

RenderContainer.propTypes = {
  isCaptureInProgress: PropTypes.bool,
  isMitekSdkReady: PropTypes.bool,
  renderContainer: PropTypes.string,
  stopImageCapture: PropTypes.func
};
